import React, { useEffect, useState } from 'react';
import PhysicianWelcomeScreen from '@medflex/components/stories/PhysicianWelcomeScreen';
import { trackEvent } from '@medflex/utils/Tracking';
import { isSameDay } from 'date-fns';
import useUserProfile from '../../hooks/useUserProfile';
import useChatContacts from '../../hooks/useChatContacts';

const VideoBox = () => {
  const { contacts } = useChatContacts();
  const { userProfile, update } = useUserProfile();
  const { videoBoxHidden } = userProfile.attributes;
  const [optimisticVideoBoxHidden, setOptimisticVideoBoxHidden] = useState(
    typeof videoBoxHidden !== 'undefined' ? videoBoxHidden : false,
  );

  useEffect(() => {
    if (typeof videoBoxHidden === 'undefined') {
      const videoBoxViews = JSON.parse(localStorage.getItem('videoBoxViews')) || [];
      if (!videoBoxViews.some(({ createdAt }) => isSameDay(createdAt, new Date()))) {
        localStorage.setItem(
          'videoBoxViews',
          JSON.stringify([...videoBoxViews, { createdAt: new Date() }]),
        );
      }

      setOptimisticVideoBoxHidden(videoBoxViews.length > 3 || contacts.length > 5);
    }
  }, [contacts, videoBoxHidden]);

  const handleToggleVideoBox = event => {
    trackEvent(event);
    update({ videoBoxHidden: !optimisticVideoBoxHidden });
    setOptimisticVideoBoxHidden(!optimisticVideoBoxHidden);
  };

  const handleVideoClick = url => event => {
    window.open(url, '_blank');
    trackEvent(event);
  };

  const videos = [
    {
      id: 'profile',
      image: '/assets/video_box_profile.png',
      duration: '1:32',
      onClick: handleVideoClick('https://www.medflex.de/anleitungen/#medflex-video1'),
    },
    {
      id: 'patients',
      image: '/assets/video_box_patients.png',
      duration: '2:52',
      onClick: handleVideoClick('https://www.medflex.de/anleitungen/#medflex-video2'),
    },
    {
      id: 'colleagues',
      image: '/assets/video_box_colleagues.png',
      duration: '1:27',
      onClick: handleVideoClick('https://www.medflex.de/anleitungen/#medflex-video3'),
    },
    {
      id: 'video',
      image: '/assets/video_box_video.png',
      duration: '1:26',
      onClick: handleVideoClick('https://www.medflex.de/anleitungen/#medflex-video4'),
    },
  ];

  return (
    <PhysicianWelcomeScreen.VideoBox
      onToggle={handleToggleVideoBox}
      summaryVideo={{
        duration: '1:20',
        image: '/assets/video_box_summary.png',
        onClick: handleVideoClick('https://www.medflex.de/anleitungen'),
      }}
      videos={videos}
      helpCenterUrl="https://medflex.de/faq-hilfe/"
      hidden={optimisticVideoBoxHidden}
    />
  );
};

export default VideoBox;
